
class Header {
    constructor(){
        this.subMenuMobileHandle();
        this.languageHandle();
    }

    subMenuMobileHandle() {
        const headerMenuMb = document.querySelector('.main-menu-mobile');
        if (!headerMenuMb){ return; }

        const menuItems = headerMenuMb.querySelectorAll('.menu-item');
        menuItems.forEach(menuItem => {
            menuItem.addEventListener('click', function(e){
                const href = e.target.getAttribute('href');
                
                if (e.target.classList.contains('menu-name')){
                    const hrefParent = e.target.parentElement.href;
                    if (!hrefParent || hrefParent === '#' || hrefParent === 'javascript:void(0)'){
                        e.preventDefault();
                        const submenu = menuItem.querySelector('.sub-menu');
                        if (submenu) {
                            // Toggle submenu
                            if (submenu.style.display === 'block') {
                                this.slideUp(submenu);
                                menuItem.classList.remove('showed');
                            } else {
                                this.slideDown(submenu);
                                menuItem.classList.add('showed');
                            }
                        }
                    }else{
                        return true;
                    }
                }

                e.preventDefault(); // Ngăn hành động mặc định
                
                const submenu = menuItem.querySelector('.sub-menu');
                if (submenu) {
                    // Toggle submenu
                    if (submenu.style.display === 'block') {
                        this.slideUp(submenu);
                        menuItem.classList.remove('showed');
                    } else {
                        this.slideDown(submenu);
                        menuItem.classList.add('showed');
                    }
                }
                // if (!href || href === '#' || href === 'javascript:void(0)') {
                // }
            }.bind(this))
        });
    }

    languageHandle(){
        const languages = document.querySelector('.languages');
        if (languages){
            const selected = languages.querySelector('.languages-selected');
            const option = languages.querySelector('.languages-option');
            if (option && selected){
                selected.addEventListener('click', function(e){
                    e.preventDefault();

                    selected.classList.toggle('clicked');

                    if (selected.classList.contains('clicked')){
                        this.slideDown(option);
                    }else{
                        this.slideUp(option);
                    }
                }.bind(this))
            }
        }
    }

    slideDown(element, duration = 400) {
        element.style.display = "block"; // Đảm bảo phần tử hiển thị
        let height = element.scrollHeight; // Lấy chiều cao thực tế
        element.style.height = "0px";
        element.style.overflow = "hidden";
        element.style.transition = `height ${duration}ms`;
    
        requestAnimationFrame(() => {
            element.style.height = `${height}px`;
        });
    
        // Reset lại sau khi hoàn tất
        setTimeout(() => {
            element.style.height = "";
            element.style.transition = "";
            element.style.overflow = "";
        }, duration);
    }

    slideUp(element, duration = 400) {
        element.style.height = `${element.scrollHeight}px`;
        element.style.overflow = "hidden";
        element.style.transition = `height ${duration}ms`;
    
        requestAnimationFrame(() => {
            element.style.height = "0px";
        });
    
        setTimeout(() => {
            element.style.display = "none"; // Ẩn sau khi hiệu ứng kết thúc
            element.style.height = "";
            element.style.transition = "";
            element.style.overflow = "";
        }, duration);
    }
}

export default Header;